import { render, staticRenderFns } from "./Fishcars.vue?vue&type=template&id=51339868"
import script from "./Fishcars.vue?vue&type=script&lang=js"
export * from "./Fishcars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports